import { UseToastOptions } from '@chakra-ui/react'

export const savedItemToastConfig: UseToastOptions = {
    duration: 6000,
}
